import { render } from "./ProjectComponentJa.vue?vue&type=template&id=7afc5d4f&scoped=true"
import script from "./ProjectComponentJa.vue?vue&type=script&lang=js"
export * from "./ProjectComponentJa.vue?vue&type=script&lang=js"

import "./ProjectComponentJa.vue?vue&type=style&index=0&id=7afc5d4f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afc5d4f"]])

export default __exports__